import { IPublicClientApplication } from "@azure/msal-browser"
import { getToken } from "Components/Functions";
import { EmployeeType, SusiUserType } from "Components/Types"
import { api } from "./apiConfig"

export const EmployeeAPI = {
    login: async function (instance: IPublicClientApplication, user:SusiUserType) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: "Employee/UserLogin",
            method: "POST",
            data: user,
            headers: { Authorization: header }
        })
        return response.data
    },
    update: async function (instance: IPublicClientApplication, employee:EmployeeType) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: "Employee/UpdateEmployee",
            method: "POST",
            data: employee,
            headers: { Authorization: header }
        })
        return response.data
    }
}